<div [@routerTransition]>
    <div *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
        <ng-container *ngIf="isBannerExists && bannerName">
            <app-webshop-banner [bannerName]="bannerName"></app-webshop-banner>
        </ng-container>
    </div>

    <div>
        <div class="item-classification">
            <h3>Relevant articles:</h3>
            <ng-container *ngIf="checkOnlineHelperFeature()">
                <helper bookmark="relevantArticles"></helper>
            </ng-container>
        </div>

        <div class="kt-portlet__body">
            <div class="order-guide-container relevant-articles">
                <ng-container *ngIf="showCarusel">
                    <p-carousel [value]="products"
                                styleClass="custom-carousel"
                                [numVisible]="6"
                                [numScroll]="2"
                                [circular]="true"
                                [autoplayInterval]="9000"
                                [style]="{'width': '100%'}"
                                style="width: 100%;">

                        <ng-template let-product pTemplate="listItem">
                            <div class="product-carousel-item card" (click)="openDetails(product)">

                                <div class="product-grid-item-content">
                                    <div class="product-image">
                                        <div class="product-image-helper"></div>
                                        <img src="{{getImgUrl(product.code)}}" alt="Article picture" />
                                    </div>
                                    <div class="product-name">{{product.title}}</div>
                                </div>
                                <div class="product-grid-item-bottom">
                                    <span class="product-price">{{product.price | currency:getCurrency(product.currency):'symbol-narrow':'.2-2'}}</span>
                                </div>
                            </div>
                        </ng-template>
                    </p-carousel>
                </ng-container>
                <div class="spinner-container" *ngIf="isLoadingArticles">
                    <p-progressSpinner></p-progressSpinner>
                </div>

            </div>
        </div>

        <div class="kt-content distribution">
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <app-combine-view
                        [hideSearch]="isLegacyUI"
                        (onQuickAction)="addToBasket($event)"
                        (loadData)="getData($event)"></app-combine-view>
                </div>
            </div>
        </div>
    </div>
</div>
